module.exports = __webpack_public_path__ + "static/media/coach.60ed7780.jpg";